import React from 'react';

/**
 * Handles the Escape key while the editor is open.
 *
 * The keydown's default is cancelled so the browser makes no close request of its own: once the
 * editor had gone, that request would reach the journey's <dialog closedby="any"> and close the
 * whole journey. A held key repeats its keydown; only the first press acts.
 */
export const createKeyDownHandler = (isEditorOpen: boolean, onEscape: () => void): ((event: KeyboardEvent) => void) => {
  return (event: KeyboardEvent) => {
    if (event.key === 'Escape' && isEditorOpen) {
      event.preventDefault();
      if (!event.repeat) onEscape();
    }
  };
};
